export const ACCEPTED_TYPES = ".pdf,.jpg,.jpeg,.png,.xlsx,.csv";
export const ACCEPTED_EXTENSIONS = ["pdf", "jpg", "jpeg", "png", "xlsx", "csv"];
export const MAX_SIZE_MB = 200;
export const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
}
